import { LIVESHOWS } from '../types'

const initialState = [];
export const liveshowsReducer = (state = initialState, action) =>{
  const {type, payload} = action

  switch (type) {
    case LIVESHOWS: {
      const { data } = payload
      state = initialState;
      return [...state, ...data]
    }
    default: {
      return state
    }
  }
}
